import React from "react";

import {convertToCountryLatLngLiteral} from "@pg-mono/open-street-map";
import {rpAppLink} from "@pg-mono/rp-routes";
import {pluralize} from "@pg-mono/string-utils";

import {rpCommonUrl} from "../../app/read_rp_environment_variables";
import {generateFallbackDescription} from "../../offer/detail/schema/description_util";
import {getOfferTypeName, getOfferTypeNameCapital} from "../../offer/helpers/OfferType";
import {OfferType} from "../../offer/types/OfferType";
import {Country} from "../../region/types/Country";
import {getThumbnailLink} from "../../utils/get_thumbnail_link";

interface IProps {
    property: {
        area: number;
        for_sale: boolean;
        id: number;
        is_active?: boolean;
        number: string;
        offer: {
            geo_point: {
                coordinates: [number, number];
            };
            id: number;
            main_image: {
                m_img_1500: string;
            };
            main_image_url?: string | null;
            name: string;
            slug: string;
            street_name: string;
            street_number: string;
            region: {
                country: Country;
                full_name: string;
                name_declension_where: string;
                stats?: {
                    region_type_city?: {name: string} | null;
                    region_type_town?: {name: string} | null;
                    region_type_voivodeship?: {name: string} | null;
                };
            };
            stats: {
                distance_from_region: {
                    center: boolean;
                    region: string;
                    distance: number;
                };
            } | null;
            type: number;
            vendor: {
                name: string;
                slug: string;
            };
        };
        price: number | null;
        rooms: number;
        floor: number;
    };
}

export const SchemaPropertyDetail: React.FunctionComponent<IProps> = (props) => {
    const {property} = props;
    const isNotCommercial = property.offer.type === OfferType.HOUSE || property.offer.type === OfferType.FLAT;
    const url = rpAppLink.property.detail.base({
        vendorSlug: property.offer.vendor.slug,
        offerSlug: property.offer.slug,
        offerId: property.offer.id,
        propertyId: property.id
    });
    const offerBaseUrl = rpAppLink.offer.detail.base({
        vendorSlug: property.offer.vendor.slug,
        offerSlug: property.offer.slug,
        offerId: property.offer.id
    });
    const {lng, lat} = convertToCountryLatLngLiteral(property.offer.geo_point.coordinates, property.offer.region.country);
    let offerType: string;
    if (property.offer.type === OfferType.HOUSE) {
        offerType = "SingleFamilyResidence";
    } else if (property.offer.type === OfferType.FLAT) {
        offerType = "Apartment";
    } else {
        offerType = "Place";
    }
    const floorSizeValue = {
        "@type": "QuantitativeValue",
        value: property.area,
        unitCode: "MTK"
    };
    const floorSize = isNotCommercial ? floorSizeValue : undefined;
    const address = `${property.offer.street_name} ${property.offer.street_number ? property.offer.street_number : ""}`.trim();
    const addressLocality =
        property.offer.region.stats?.region_type_city?.name || property.offer.region.stats?.region_type_town?.name || property.offer.region.full_name;
    const addressRegion = property.offer.region.stats?.region_type_voivodeship?.name ?? undefined;
    const roomPluralize = pluralize(["pokój", "pokoje", "pokoi"]);
    const floorText = property.floor === 0 ? "Parter" : `${property.floor} piętro`;
    const name = `${property.offer.name} - ${getOfferTypeName(property.offer.type)} ${property.rooms} ${roomPluralize(property.rooms)}, ${property.area} m², ${floorText}`;
    const description = `${getOfferTypeNameCapital(property.offer.type)} na sprzedaż ${property.rooms} ${roomPluralize(property.rooms)} o powierzchni ${
        property.area
    } m²`;

    const image = getThumbnailLink(property.offer.main_image_url, 1500) ?? property.offer.main_image.m_img_1500;
    const hasPriceForProduct = property.is_active && !!property.price;

    const productSchema = {
        "@context": "https://schema.org/",
        "@type": "Product",
        name: name,
        image: image,
        description: description ? description : generateFallbackDescription(property.offer),
        brand: {
            "@type": "Brand",
            name: property.offer.vendor.name
        },
        offers: {
            "@type": "Offer",
            url: `${rpCommonUrl}${url}`,
            priceCurrency: "PLN",
            price: property.price,
            availability: property.for_sale ? "https://schema.org/InStock" : "https://schema.org/SoldOut",
            itemCondition: "https://schema.org/NewCondition"
        }
    };

    const apartmentSchema = {
        "@context": "https://schema.org/",
        "@type": offerType,
        name: property.number,
        floorLevel: offerType === "Apartment" ? String(property.floor) : undefined,
        numberOfRooms: isNotCommercial ? property.rooms : undefined,
        floorSize,
        url: `${rpCommonUrl}${url}`,
        image: image,
        description: description ? description : generateFallbackDescription(property.offer),
        containedInPlace: {
            "@type": "Residence",
            name: property.offer.name,
            url: `${rpCommonUrl}${offerBaseUrl}`
        },
        address: {
            "@type": "PostalAddress",
            streetAddress: address,
            addressLocality: addressLocality,
            addressRegion: addressRegion,
            addressCountry: "PL"
        },
        geo: {
            "@type": "GeoCoordinates",
            latitude: lat,
            longitude: lng
        }
    };

    const schema = [apartmentSchema, ...(hasPriceForProduct ? [productSchema] : [])];

    return (
        <span>
            <script type="application/ld+json" dangerouslySetInnerHTML={{__html: JSON.stringify(schema)}} />
        </span>
    );
};
import React from "react";

import {convertToCountryLatLngLiteral} from "@pg-mono/open-street-map";
import {rpAppLink} from "@pg-mono/rp-routes";
import {pluralize} from "@pg-mono/string-utils";

import {rpCommonUrl} from "../../app/read_rp_environment_variables";
import {generateFallbackDescription} from "../../offer/detail/schema/description_util";
import {getOfferTypeName, getOfferTypeNameCapital} from "../../offer/helpers/OfferType";
import {OfferType} from "../../offer/types/OfferType";
import {Country} from "../../region/types/Country";
import {getThumbnailLink} from "../../utils/get_thumbnail_link";

interface IProps {
    property: {
        area: number;
        for_sale: boolean;
        id: number;
        is_active?: boolean;
        number: string;
        offer: {
            geo_point: {
                coordinates: [number, number];
            };
            id: number;
            main_image: {
                m_img_1500: string;
            };
            main_image_url?: string | null;
            name: string;
            slug: string;
            street_name: string;
            street_number: string;
            region: {
                country: Country;
                full_name: string;
                name_declension_where: string;
                stats?: {
                    region_type_city?: {name: string} | null;
                    region_type_town?: {name: string} | null;
                    region_type_voivodeship?: {name: string} | null;
                };
            };
            stats: {
                distance_from_region: {
                    center: boolean;
                    region: string;
                    distance: number;
                };
            } | null;
            type: number;
            vendor: {
                name: string;
                slug: string;
            };
        };
        price: number | null;
        rooms: number;
        floor: number;
    };
}

export const SchemaPropertyDetail: React.FunctionComponent<IProps> = (props) => {
    const {property} = props;
    const isNotCommercial = property.offer.type === OfferType.HOUSE || property.offer.type === OfferType.FLAT;
    const url = rpAppLink.property.detail.base({
        vendorSlug: property.offer.vendor.slug,
        offerSlug: property.offer.slug,
        offerId: property.offer.id,
        propertyId: property.id
    });
    const offerBaseUrl = rpAppLink.offer.detail.base({
        vendorSlug: property.offer.vendor.slug,
        offerSlug: property.offer.slug,
        offerId: property.offer.id
    });
    const {lng, lat} = convertToCountryLatLngLiteral(property.offer.geo_point.coordinates, property.offer.region.country);
    let offerType: string;
    if (property.offer.type === OfferType.HOUSE) {
        offerType = "SingleFamilyResidence";
    } else if (property.offer.type === OfferType.FLAT) {
        offerType = "Apartment";
    } else {
        offerType = "Place";
    }
    const floorSizeValue = {
        "@type": "QuantitativeValue",
        value: property.area,
        unitCode: "MTK"
    };
    const floorSize = isNotCommercial ? floorSizeValue : undefined;
    const address = `${property.offer.street_name} ${property.offer.street_number ? property.offer.street_number : ""}`.trim();
    const addressLocality =
        property.offer.region.stats?.region_type_city?.name || property.offer.region.stats?.region_type_town?.name || property.offer.region.full_name;
    const addressRegion = property.offer.region.stats?.region_type_voivodeship?.name ?? undefined;
    const roomPluralize = pluralize(["pokój", "pokoje", "pokoi"]);
    const floorText = property.floor === 0 ? "Parter" : `${property.floor} piętro`;
    const name = `${property.offer.name} - ${getOfferTypeName(property.offer.type)} ${property.rooms} ${roomPluralize(property.rooms)}, ${property.area} m², ${floorText}`;
    const description = `${getOfferTypeNameCapital(property.offer.type)} na sprzedaż ${property.rooms} ${roomPluralize(property.rooms)} o powierzchni ${
        property.area
    } m²`;

    const image = getThumbnailLink(property.offer.main_image_url, 1500) ?? property.offer.main_image.m_img_1500;
    const hasPriceForProduct = property.is_active && !!property.price;

    const productSchema = {
        "@context": "https://schema.org/",
        "@type": "Product",
        name: name,
        image: image,
        description: description ? description : generateFallbackDescription(property.offer),
        brand: {
            "@type": "Brand",
            name: property.offer.vendor.name
        },
        offers: {
            "@type": "Offer",
            url: `${rpCommonUrl}${url}`,
            priceCurrency: "PLN",
            price: property.price,
            availability: property.for_sale ? "https://schema.org/InStock" : "https://schema.org/SoldOut",
            itemCondition: "https://schema.org/NewCondition"
        }
    };

    const apartmentSchema = {
        "@context": "https://schema.org/",
        "@type": offerType,
        name: property.number,
        floorLevel: offerType === "Apartment" ? String(property.floor) : undefined,
        numberOfRooms: isNotCommercial ? property.rooms : undefined,
        floorSize,
        url: `${rpCommonUrl}${url}`,
        image: image,
        description: description ? description : generateFallbackDescription(property.offer),
        containedInPlace: {
            "@type": "Residence",
            name: property.offer.name,
            url: `${rpCommonUrl}${offerBaseUrl}`
        },
        address: {
            "@type": "PostalAddress",
            streetAddress: address,
            addressLocality: addressLocality,
            addressRegion: addressRegion,
            addressCountry: "PL"
        },
        geo: {
            "@type": "GeoCoordinates",
            latitude: lat,
            longitude: lng
        }
    };

    const schema = [apartmentSchema, ...(hasPriceForProduct ? [productSchema] : [])];

    return (
        <span>
            <script type="application/ld+json" dangerouslySetInnerHTML={{__html: JSON.stringify(schema)}} />
        </span>
    );
};
